import { QuickPoll } from 'src/domain/quick-poll';

export const hasUserAnswered = (poll: QuickPoll): boolean => (poll.selectedAnswerIds ?? []).length > 0;
